import React from 'react';
import { IconLock, IconEnvelopeSimple, IconUser } from 'src/viewLayer/components/DesignSystem';

const IconMapping: {[key: string]: JSX.Element} = {
  IconLock: <IconLock />,
  IconEnvelopeSimple: <IconEnvelopeSimple />,
  IconUser: <IconUser />
};

export const getInputIcon = (iconName: string): JSX.Element => IconMapping[iconName];
